import React from "react";
import { Reveal } from "@/components/Reveal";
import { LeadForm } from "@/components/LeadForm";
import { SITE, waLink } from "@/data/site";
import { Phone, Mail, MapPin, MessageCircle, Clock } from "lucide-react";
import useSeo from "@/lib/useSeo";

export default function Contact() {
  useSeo({ title: "Contact", description: "Reach VacanzaGo in Haridwar — WhatsApp, call or email. Plan your journey or event with our team." });
  return (
    <div className="pt-28 pb-24 bg-[#FFF7EC] min-h-screen">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        <Reveal className="max-w-3xl mb-12">
          <p className="eyebrow">Let's plan the journey</p>
          <h1 className="font-display text-5xl sm:text-6xl font-medium tracking-tight mt-3 text-[#2A1808]">Talk to us</h1>
          <p className="mt-4 text-lg text-[#553204]">Tell us your group, dates and what matters most. We'll send a tailored, itemised plan within one business day.</p>
        </Reveal>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <Reveal>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
              <a href={waLink()} target="_blank" rel="noreferrer" data-testid="contact-whatsapp" className="rounded-md border border-[#553204]/10 bg-[#FFFBF5] p-5 hover:border-[#F49E1A] transition-colors">
                <MessageCircle className="text-[#25D366]" /><p className="font-semibold mt-3 text-[#2A1808]">WhatsApp</p><p className="text-sm text-[#8A6B47]">{SITE.phone}</p>
              </a>
              <a href={`tel:${SITE.phoneRaw}`} data-testid="contact-call" className="rounded-md border border-[#553204]/10 bg-[#FFFBF5] p-5 hover:border-[#F49E1A] transition-colors">
                <Phone className="text-[#F49E1A]" /><p className="font-semibold mt-3 text-[#2A1808]">Call</p><p className="text-sm text-[#8A6B47]">{SITE.phone}</p>
              </a>
              <a href={`mailto:${SITE.email}`} data-testid="contact-email" className="rounded-md border border-[#553204]/10 bg-[#FFFBF5] p-5 hover:border-[#F49E1A] transition-colors">
                <Mail className="text-[#F49E1A]" /><p className="font-semibold mt-3 text-[#2A1808]">Email</p><p className="text-sm text-[#8A6B47]">{SITE.email}</p>
              </a>
              <div className="rounded-md border border-[#553204]/10 bg-[#FFFBF5] p-5">
                <MapPin className="text-[#F49E1A]" /><p className="font-semibold mt-3 text-[#2A1808]">Based in</p><p className="text-sm text-[#8A6B47]">{SITE.city}</p>
              </div>
            </div>
            <div className="rounded-md overflow-hidden border border-[#553204]/10 h-72">
              <iframe title="VacanzaGo location" src={SITE.mapEmbed} className="w-full h-full border-0" loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-testid="contact-map" />
            </div>
          </Reveal>

          <Reveal delay={100}>
            <div className="rounded-md border border-[#553204]/10 bg-[#FFFBF5] p-7">
              <h2 className="font-display text-2xl text-[#2A1808] mb-5">Send an enquiry</h2>
              <LeadForm source="contact" buttonLabel="Send enquiry" waPrefix="Hi Vacanza Go, I'd like to enquire about a journey." />
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  );
}
